export const INTERCOM_LAUNCHER_BUTTON_ID = '#intercom-launcher-button'
